import {
    ComponentFactoryResolver,
    ComponentRef,
    Directive,
    Input,
    OnChanges,
    OnDestroy,
    OnInit,
    ViewContainerRef
} from '@angular/core';
import {UntypedFormGroup} from '@angular/forms';
import {FieldTypeToComponent} from '../fields/field-type-to-component';
import {DynamicFieldComponent} from './dynamic-field-component';
import {FieldConfigWrapper} from './field-config-wrapper';

@Directive({
    selector: '[mydocmaDynamicField]',
})
export class DynamicFieldDirective implements DynamicFieldComponent, OnInit, OnChanges, OnDestroy {

    @Input()
    public fieldWrapper: FieldConfigWrapper<any>;

    @Input()
    public formGroup: UntypedFormGroup;

    @Input()
    public maxCollapsedWidth: number = null;

    public component: ComponentRef<DynamicFieldComponent>;

    private fieldTypeToComponent = FieldTypeToComponent;

    constructor(
        private readonly resolver: ComponentFactoryResolver,
        private readonly container: ViewContainerRef,
    ) {
    }

    /**
     * Lifecycle hook that is called after data-bound properties of a directive are initialized.
     */
    public ngOnInit() {
        if (!this.fieldTypeToComponent.has(this.fieldWrapper.config.type)) {
            throw new Error(
                `Field component not found. Trying to use an unsupported field type (${this.fieldWrapper.config.type})`
            );
        }

        const componentType = this.fieldTypeToComponent.get(this.fieldWrapper.config.type);
        const componentFactory = this.resolver.resolveComponentFactory<DynamicFieldComponent>(componentType);
        this.component = this.container.createComponent(componentFactory);
        this.component.instance.fieldWrapper = this.fieldWrapper;
        this.component.instance.formGroup = this.formGroup;
        if (this.maxCollapsedWidth !== null) {
            this.component.instance.maxCollapsedWidth = this.maxCollapsedWidth;
        }
    }

    /**
     * A lifecycle hook that is called when any data-bound property of a directive changes.
     *
     * @param changes - changes
     */
    public ngOnChanges() {
        if (this.component) {
            this.component.instance.fieldWrapper = this.fieldWrapper;
            this.component.instance.formGroup = this.formGroup;
            if (this.maxCollapsedWidth !== null) {
                this.component.instance.maxCollapsedWidth = this.maxCollapsedWidth;
            }
        }
    }

    public ngOnDestroy(): void {
        this.component?.destroy();
        this.component = null;
    }
}
